import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/certidao.css';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';
import AUTO_TEXTO_CERTIDAO from './AutoTextoCertidao';

class CamposAutoTexto extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            componentes: computed,
            magistrados: computed,
            localizacaoUsuario: computed,
            advogados: computed,
            certidaoGerada: computed,
            naoTemInscricaoAdvogado: computed,
            naoTemParticipacaoPresencial: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get componentes() {
        if (this.observableProps.listaComponentes) {
            return this.observableProps.listaComponentes;
        }

        const listaComponentes = [
            AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.id,
            AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.id,
            AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO.id,
            AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.id,
            AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.id,
            AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.id,
            AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.id,
            AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.id,
            AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.id,
            AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.id
        ];

        return listaComponentes;
    }

    get magistrados() {
        return this.observableProps.magistrados.filter(
            (magistrado) => this.localizacaoUsuario === 'CSJT' || !magistrado.valor.sigla.startsWith('CS')
        );
    }

    get localizacaoUsuario() {
        return this.usuarioStore.usuario.localizacao;
    }

    get advogados() {
        return this.observableProps.advogados;
    }

    get certidaoGerada() {
        return this.observableProps.id !== 'certidao' && this.registro.certidaoGerada;
    }

    get naoTemInscricaoAdvogado() {
        return !this.registro.pedidoSustentacaoOral;
    }

    get naoTemParticipacaoPresencial() {
        return !this.salaSessaoStore.temPartipacaoSessao(this.registro);
    }

    render() {
        const estiloPadraoGrid = { gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: 3 };
        const estiloGrid = this.observableProps.estiloGrid ? this.observableProps.estiloGrid : estiloPadraoGrid;

        if (!this.registro) {
            return null;
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '6px', flexGrow: 5 }}>
                <div style={{ display: 'grid', ...estiloGrid }}>
                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.id) && (
                        <AutoComplete
                            alinhamentoCima
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.legenda}
                            options={this.advogados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.id,
                                    option
                                )
                            }
                            style={{ margin: '0px 5px 0px 0px' }}
                            disabled={this.certidaoGerada || this.naoTemInscricaoAdvogado}
                            title={
                                !this.naoTemInscricaoAdvogado
                                    ? 'Registro de presença/participação virtual'
                                    : 'Não há inscrição de advogado para este processo.'
                            }
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.id) && (
                        <AutoComplete
                            alinhamentoCima
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.legenda}
                            options={this.advogados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.id,
                                    option
                                )
                            }
                            style={{ margin: '0px 5px 0px 0px' }}
                            disabled={
                                this.certidaoGerada ||
                                (this.naoTemInscricaoAdvogado && this.naoTemParticipacaoPresencial)
                            }
                            title={
                                this.naoTemInscricaoAdvogado && this.naoTemParticipacaoPresencial
                                    ? 'Não há inscrição de advogado (preferência/sustentação) para este processo.'
                                    : 'Sustentação Oral'
                            }
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO.id) && (
                        <AutoComplete
                            alinhamentoCima
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO.legenda}
                            options={this.advogados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO.id,
                                    option
                                )
                            }
                            style={{ margin: '0px 5px 0px 0px' }}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.id) && (
                        <AutoComplete
                            alinhamentoCima
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.id, option)
                            }
                            id={AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.id) && (
                        <AutoComplete
                            alinhamentoCima
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.id,
                                    option
                                )
                            }
                            id={AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.id) && (
                        <AutoComplete
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.id,
                                    option
                                )
                            }
                            id={AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.id) && (
                        <AutoComplete
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.id,
                                    option
                                )
                            }
                            id={AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.id) && (
                        <AutoComplete
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.id,
                                    option
                                )
                            }
                            id={AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.id) && (
                        <AutoComplete
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.id,
                                    option
                                )
                            }
                            id={AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}

                    {this.componentes.includes(AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.id) && (
                        <AutoComplete
                            desabilitarLimpar
                            apresentarTextoSecundario
                            label={AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.legenda}
                            options={this.magistrados}
                            onChange={(option) =>
                                this.observableProps.callbackAutoComplete(
                                    AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.id,
                                    option
                                )
                            }
                            id={AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.id + this.observableProps.id}
                            style={{ margin: '0px 5px 0px 0px' }}
                            limparCampo={true}
                            disabled={this.certidaoGerada}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(CamposAutoTexto));
